// removed by extract-text-webpack-plugin
module.exports = {"documentFailure":"documentFailure__documentFailure___1oo5G"};


//////////////////
// WEBPACK FOOTER
// ./src/pdf/documentFailure.scss
// module id = 1252
// module chunks = 0